import React, { useState } from 'react';
import { useUpdateProject } from '../hooks/useUpdateProject';

interface CommentsInputProps {
    projectId: string;
    fileId: string;
    disabled?: boolean;
    defaultValue?: string;
    onFinish: () => void;
}

const CommentsInput: React.FC<CommentsInputProps> = ({
    projectId,
    fileId,
    disabled = false,
    defaultValue = '',
    onFinish,
}) => {
    const { updateDmProjectFileHook } = useUpdateProject();
    const [value, setValue] = useState(defaultValue);

    const handleBlur = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        updateDmProjectFileHook(projectId, fileId, { comments: e.target.value });
        onFinish?.();
    }

    return (
        <textarea
            value={value}
            onChange={e => setValue(e.target.value)}
            onBlur={handleBlur}
            placeholder={"Comments go here..."}
            disabled={disabled}
            rows={1}
            onKeyDown={(e) => {
                if (e.key === ' ') {
                    e.stopPropagation();
                }
            }}
            style={{
                width: '100%',
                fontSize: '14px',
                border: '1px solid #ccc',
                borderRadius: '6px',
                padding: '6px 10px',
                outline: 'none',
                boxSizing: 'border-box',
                background: disabled ? '#f5f5f5' : '#fff',
                color: '#222',
                minHeight: '32px',
                maxHeight: '80px',
                resize: 'vertical',
            }}
        />
    );
};

export default CommentsInput; 